export default "__VITE_ASSET__TuKTEzYJ__"